import type { AuditEntry } from "@/services/types";

/**
 * Audit trail spanning several weeks and every audited action type. Entries
 * reference records that actually exist (members, groups, receipts, vouchers)
 * and the staff users defined in the user list. This is read-only.
 */
export const MOCK_AUDIT: AuditEntry[] = [
  {
    id: "a-01",
    timestamp: "2026-08-25T09:10:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01041",
    narration: "Recorded cash payment of ₹4,250 from Member #MEM0003 for Laxmi-12 C8.",
    changes: [],
  },
  {
    id: "a-02",
    timestamp: "2026-08-25T09:06:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01040",
    narration: "Recorded UPI payment of ₹4,000 from Member #MEM0015 across two demands.",
    changes: [],
  },
  {
    id: "a-03",
    timestamp: "2026-08-25T08:58:00.000Z",
    userName: "Ramesh Gupta",
    userRole: "super_admin",
    action: "approve_payout",
    module: "Payout",
    entity: "Voucher #PV000127",
    narration: "Approved payout to Member #MEM0034 for Shree-9 C5.",
    changes: [{ field: "Status", before: "Awaiting approval", after: "Approved" }],
  },
  {
    id: "a-04",
    timestamp: "2026-08-24T15:00:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01039",
    narration: "Recorded cash payment of ₹4,250 from Member #MEM0022 for Laxmi-12 C8.",
    changes: [],
  },
  {
    id: "a-05",
    timestamp: "2026-08-24T12:50:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "reverse_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01018",
    narration: "Reversed receipt recorded to the wrong member; amount credited back.",
    changes: [
      { field: "Reversal reason", before: "", after: "Recorded against the wrong member in the queue" },
    ],
  },
  {
    id: "a-06",
    timestamp: "2026-08-24T10:20:00.000Z",
    userName: "Priya Sharma",
    userRole: "accountant",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01038",
    narration: "Recorded bank transfer payment of ₹8,500 from Member #MEM0009 (two tickets).",
    changes: [],
  },
  {
    id: "a-07",
    timestamp: "2026-08-23T11:05:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01037",
    narration: "Recorded cash payment of ₹4,000 from Member #MEM0018 for Shree-9 C6.",
    changes: [],
  },
  {
    id: "a-08",
    timestamp: "2026-08-23T09:10:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "apply_late_fee",
    module: "Collection",
    entity: "Demand · Laxmi-12 C7",
    narration: "Applied late fees to 4 overdue demands at ₹50 each.",
    changes: [
      { field: "Fee applied", before: "None", after: "₹50 × 4 demands" },
    ],
  },
  {
    id: "a-09",
    timestamp: "2026-08-22T12:15:00.000Z",
    userName: "Priya Sharma",
    userRole: "accountant",
    action: "waive_late_fee",
    module: "Collection",
    entity: "Demand · Shree-9 C6",
    narration: "Waived late fee for Member #MEM0007 after a documented medical emergency.",
    changes: [
      { field: "Fee", before: "₹50", after: "Waived" },
    ],
  },
  {
    id: "a-10",
    timestamp: "2026-08-22T10:30:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01036",
    narration: "Recorded cash payment of ₹4,250 from Member #MEM0027 for Laxmi-12 C8.",
    changes: [],
  },
  {
    id: "a-11",
    timestamp: "2026-08-22T09:45:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01035",
    narration: "Recorded cheque payment of ₹17,000 from Member #MEM0011 across four demands.",
    changes: [],
  },
  {
    id: "a-12",
    timestamp: "2026-08-21T14:40:00.000Z",
    userName: "Priya Sharma",
    userRole: "accountant",
    action: "disburse_payout",
    module: "Payout",
    entity: "Voucher #PV000126",
    narration: "Disbursed ₹78,400 to Member #MEM0012 for Ganesh-6 C4 by bank transfer.",
    changes: [{ field: "Amount paid", before: "₹0", after: "₹78,400" }],
  },
  {
    id: "a-13",
    timestamp: "2026-08-21T11:20:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01034",
    narration: "Recorded cash payment of ₹4,250 from Member #MEM0005 for Laxmi-12 C8.",
    changes: [],
  },
  {
    id: "a-14",
    timestamp: "2026-08-21T10:05:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "close_auction",
    module: "Auction",
    entity: "Auction · Shree-9 C6",
    narration: "Closed auction. Winner Member #MEM0018 at ₹76,000; dividend ₹205 per member.",
    changes: [
      { field: "Winning bid", before: "", after: "₹76,000" },
      { field: "Per-member dividend", before: "", after: "₹205.00" },
    ],
  },
  {
    id: "a-15",
    timestamp: "2026-08-20T16:20:00.000Z",
    userName: "Ramesh Gupta",
    userRole: "super_admin",
    action: "update_setting",
    module: "Settings",
    entity: "Business profile",
    narration: "Updated business phone number and GST registration details.",
    changes: [
      { field: "Primary phone", before: "+91 98100 12000", after: "+91 98100 12345" },
      { field: "Registration number", before: "", after: "GSTIN 23AABFG1123K1Z5" },
    ],
  },
  {
    id: "a-16",
    timestamp: "2026-08-20T10:30:00.000Z",
    userName: "Ramesh Gupta",
    userRole: "super_admin",
    action: "update_setting",
    module: "Settings",
    entity: "Document numbering",
    narration: "Moved receipt sequence forward to #RCPT01042 and enabled annual reset.",
    changes: [
      { field: "Receipt next number", before: "1041", after: "1042" },
      { field: "Reset annually", before: "No", after: "Yes" },
    ],
  },
  {
    id: "a-17",
    timestamp: "2026-08-20T09:15:00.000Z",
    userName: "Neha Verma",
    userRole: "super_admin",
    action: "create_user",
    module: "Settings",
    entity: "User · Rajesh Iyer",
    narration: "Created a Collection Agent account for Rajesh Iyer.",
    changes: [
      { field: "Role", before: "", after: "Collection Agent" },
      { field: "Status", before: "", after: "Active" },
    ],
  },
  {
    id: "a-18",
    timestamp: "2026-08-19T14:05:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "enroll",
    module: "Groups",
    entity: "Group · Laxmi-12",
    narration: "Enrolled Member #MEM0031 and allotted ticket #18.",
    changes: [
      { field: "Ticket number", before: "", after: "18" },
    ],
  },
  {
    id: "a-19",
    timestamp: "2026-08-19T11:40:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "update",
    module: "Members",
    entity: "Member #MEM0025",
    narration: "Updated alternate phone and address for Member #MEM0025.",
    changes: [
      { field: "Alternate phone", before: "+91 90000 00000", after: "+91 98450 11223" },
      { field: "City", before: "Indore", after: "Ujjain" },
    ],
  },
  {
    id: "a-20",
    timestamp: "2026-08-18T16:55:00.000Z",
    userName: "Ramesh Gupta",
    userRole: "super_admin",
    action: "update_user",
    module: "Settings",
    entity: "User · Priya Sharma",
    narration: "Changed Priya Sharma's role from Collection Agent to Accountant.",
    changes: [
      { field: "Role", before: "Collection Agent", after: "Accountant" },
    ],
  },
  {
    id: "a-21",
    timestamp: "2026-08-18T10:30:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "activate",
    module: "Groups",
    entity: "Group · Sai-8",
    narration: "Activated group Sai-8 with 8 members, chit value ₹80,000.",
    changes: [
      { field: "Status", before: "Draft", after: "Active" },
    ],
  },
  {
    id: "a-22",
    timestamp: "2026-08-17T13:20:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "withdraw_bid",
    module: "Auction",
    entity: "Auction · Ganesh-6 C4",
    narration: "Withdrew a standing bid placed by Member #MEM0028 at staff request.",
    changes: [
      { field: "Bid", before: "Standing ₹79,000", after: "Withdrawn" },
    ],
  },
  {
    id: "a-23",
    timestamp: "2026-08-17T09:05:00.000Z",
    userName: "Suresh Kumar",
    userRole: "collection_agent",
    action: "record_bid",
    module: "Auction",
    entity: "Auction · Ganesh-6 C4",
    narration: "Recorded a bid of ₹78,000 for Member #MEM0002.",
    changes: [
      { field: "Bid amount", before: "", after: "₹78,000" },
    ],
  },
  {
    id: "a-24",
    timestamp: "2026-08-16T15:45:00.000Z",
    userName: "Ramesh Gupta",
    userRole: "super_admin",
    action: "deactivate_user",
    module: "Settings",
    entity: "User · Pooja Singh",
    narration: "Deactivated Pooja Singh after her resignation. Login blocked, history preserved.",
    changes: [
      { field: "Status", before: "Active", after: "Inactive" },
    ],
  },
  {
    id: "a-25",
    timestamp: "2026-08-16T11:10:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "reset_password",
    module: "Settings",
    entity: "User · Vikram Mehta",
    narration: "Reset password for Vikram Mehta and shared a temporary password.",
    changes: [],
  },
  {
    id: "a-26",
    timestamp: "2026-08-15T10:00:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "remove",
    module: "Groups",
    entity: "Group · Sai-8 (draft)",
    narration: "Removed Member #MEM0019 from draft group Sai-8 before activation.",
    changes: [
      { field: "Ticket", before: "#6", after: "Released" },
    ],
  },
  {
    id: "a-27",
    timestamp: "2026-08-14T16:30:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "create",
    module: "Members",
    entity: "Member #MEM0075",
    narration: "Created a new member record for Sunita Jha.",
    changes: [
      { field: "Member code", before: "", after: "MEM0075" },
      { field: "Status", before: "", after: "Active" },
    ],
  },
  {
    id: "a-28",
    timestamp: "2026-08-14T09:20:00.000Z",
    userName: "Neha Verma",
    userRole: "super_admin",
    action: "reverse_payout",
    module: "Payout",
    entity: "Voucher #PV000110",
    narration: "Reversed a wrongly recorded disbursement of ₹65,000 to Member #MEM0013.",
    changes: [
      { field: "Status", before: "Disbursed", after: "Reversed" },
    ],
  },
  {
    id: "a-29",
    timestamp: "2026-08-13T12:00:00.000Z",
    userName: "Priya Sharma",
    userRole: "accountant",
    action: "ledger_adjust",
    module: "Ledger",
    entity: "Ledger · Member #MEM0016",
    narration: "Credit adjustment of ₹200 to correct a rounding error on dividend entry.",
    changes: [
      { field: "Adjustment", before: "", after: "Credit ₹200" },
    ],
  },
  {
    id: "a-30",
    timestamp: "2026-08-12T10:45:00.000Z",
    userName: "Anita Desai",
    userRole: "admin",
    action: "record_receipt",
    module: "Collection",
    entity: "Receipt #RCPT01033",
    narration: "Recorded cash payment of ₹4,250 from Member #MEM0001 for Laxmi-12 C8.",
    changes: [],
  },
];